import { useCallback, useRef, useState } from "react";
import { ArrowUpRight } from "lucide-react";

import { getLoadId } from "@/utils/load";
import { LoadboardLabel, LoadboardValue, LoadboardModal, NotSpecifiedValue } from "@/components/dataPages/loadboard";

// Commodity strings can be arbitrarily long. Render on one truncated line and, only when the text
// actually overflows, show a button opening a small dialog with the full text (Figma 8580-111374/111710).
export const CommodityValue = ({ load }) => {
    const [isTruncated, setIsTruncated] = useState(false);
    const [open, setOpen] = useState(false);
    const observerRef = useRef(null);

    const textRef = useCallback((node) => {
        observerRef.current?.disconnect();
        observerRef.current = null;
        if (node) {
            observerRef.current = new ResizeObserver(() => {
                setIsTruncated(node.scrollWidth > node.clientWidth);
            });
            observerRef.current.observe(node);
        }
    }, []);

    if (!load.transportedCommodity) {
        return <NotSpecifiedValue />;
    }

    const loadId = load.externalLoadId || getLoadId(load.uniqueId);

    return (
        <div className="flex flex-row items-center gap-1 w-full">
            <LoadboardValue ref={textRef} className="min-w-0 flex-1 truncate font-medium">
                {load.transportedCommodity}
            </LoadboardValue>
            {isTruncated ? (
                <LoadboardModal
                    title={`Load #${loadId}`}
                    open={open}
                    onOpenChange={setOpen}
                    buttonClassName="shrink-0 flex size-6 items-center justify-center rounded-[4px] bg-cm-p-container-green text-cm-p-on-container-green"
                    buttonChildren={<ArrowUpRight className="w-3.5 h-3.5" />}
                    contentClassName="w-[400px] p-0 pb-3 gap-0 border-cm-p-background text-cm-p-text-primary"
                    headerClassName="h-auto px-4 py-3"
                    closeButtonClassName="w-8 h-8 rounded-[4px] bg-cm-p-surface-hover"
                >
                    <div className="flex flex-col gap-1 px-4">
                        <LoadboardLabel text="Commodity" />
                        <LoadboardValue className="break-words font-medium">{load.transportedCommodity}</LoadboardValue>
                    </div>
                </LoadboardModal>
            ) : null}
        </div>
    );
};
